export const START_LOADING_TAB_LISTING =
  'step-analysis/start-loading-tab-listing';
export const FINISH_LOADING_TAB_LISTING =
  'step-analysis/finish-loading-tab-listing';
export const SELECT_TAB = 'step-analysis/select-tab';
export const START_LOADING_SAVED_TAB = 'step-analysis/start-loading-saved-tab';
export const FINISH_LOADING_SAVED_TAB =
  'step-analysis/finish-loading-saved-tab';
export const START_LOADING_CHOSEN_ANALYSIS_TAB =
  'step-analysis/start-loading-chosen-analysis-tab';
export const FINISH_LOADING_CHOSEN_ANALYSIS_TAB =
  'step-analysis/finish-loading-chosen-analysis-tab';
export const CREATE_NEW_TAB = 'step-analysis/create-new-tab';
export const DELETE_ANALYSIS = 'step-analysis/delete-analysis';
export const REMOVE_TAB = 'step-analysis/remove-tab';
export const START_FORM_SUBMISSION = 'step-analysis/start-form-submission';
export const RUN_ANALYSIS = 'step-analysis/run-analysis';
export const CHECK_RESULT_STATUS = 'step-analysis/check-result-status';
export const COUNT_DOWN = 'step-analysis/count-down';
export const FINISH_FORM_SUBMISSION = 'step-analysis/finish-form-submission';
export const RENAME_ANALYSIS = 'step-analysis/rename-analysis';
export const RENAME_TAB = 'step-analysis/rename-tab';
export const DUPLICATE_ANALYSIS = 'step-analysis/duplicate-analysis';
export const UPDATE_PARAM_VALUES = 'step-analysis/update-param-values';
export const TOGGLE_DESCRIPTION = 'step-analysis/toggle-description';
export const TOGGLE_PARAMETERS = 'step-analysis/toggle-parameters';
